<template>
	<div class='c-select noselect'
		:class='{"c-select-active": isOpened, "is-error": error}'
		ref='c-select'
	>
		<div class='c-select__field' @click='clickHandle'>
			<div class='c-select__label'>{{selectedLabel}}</div>
			<icon icon-name='arrow' />
		</div>
		<div class='c-select__options'
			v-show='isOpened'
			:style='optionsStyles'
			v-click-outside='hideHandle'
		>
			<div class='c-select__option'
				v-for='(option, i) in options'
				:key='(option.value)?(`select-${option.value}`):(i)'
				@click='selectHandle(option)'>
				{{option.label}}
			</div>
		</div>
		<span v-if='error' class='input__labels' >{{error}}</span>
	</div>
</template>

<script>
import icon from '__jsVueUI/icon.vue';
import EventBus from '__jsEbentBus';
import ClickOutside from 'vue-click-outside';
export default {
	name:  'c-select',
	props: {
		options: {
			type:    Array,
			default: () => {
				return [];
			}
		},
		value: {
			type:    [Number, String],
			default: ''
		},
		unKey: {
			type:    String,
			default: ''
		},
		autoopen: {
			type:    Boolean,
			default: false
		},
		error: {
			type:    String,
			default: ''
		},
	},
	components: {
		icon
	},
	data() {
		return {
			isOpened:       false,
			scrollListener:      null,
			optionsStyles:  {
				top:       0,
				left:      0,
				width:     0,
				maxHeight:  0,
			}
		};
	},
	mounted() {
		this.setOptionStyles();
		EventBus.$on(`click-${this.unKey}`, (data) => {
			setTimeout(() => {
				this.isOpened = !this.isOpened;
			}, 0);
		});
		EventBus.$on('onscroll', () => {
			this.setOptionStyles();
		});
	},
	beforeDestroy() {
		EventBus.$off('onscroll');
		EventBus.$off(`click-${this.unKey}`);
	},
	methods: {
		clickHandle() {
			setTimeout(() => {
				this.isOpened = true;
			}, 100);
		},
		hideHandle() {
			if (this.isOpened) {
				this.isOpened = false;
			}
		},
		setOptionStyles() {
			let element = this.$refs['c-select'];
			let boundingClientRect = element.getBoundingClientRect();
			this.optionsStyles.top = boundingClientRect.y + boundingClientRect.height + 'px';
			this.optionsStyles.left = boundingClientRect.x + 'px';
			this.optionsStyles.width = boundingClientRect.width + 'px';
			this.optionsStyles.maxHeight = this.options.length * 36 + 'px';
		},
		selectHandle(option) {
			this.model = option.value;
			this.isOpened = false;
		}
	},
	computed: {
		selectedLabel() {
			let index = this.options.map((option) => {
				return option.value;
			}).indexOf(this.model);
			if (index > -1) {
				return this.options[index].label;
			}
			return '';
		},
		model: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
				this.$emit('complete', newVal);
			}
		},
	},
	directives: {
		ClickOutside
	},
};
</script>
